/**
 * Human-readable announcement text for push notifications and in-app previews.
 * Strips the structured body marker (`<!--ascend-announcement:…-->`) and falls
 * back to sensible summaries for poll/jobs/leave payloads when there is no
 * plaintext after the marker.
 */

const STRUCTURED_MARKER = /^<!--ascend-announcement:([\s\S]+?)-->(?:\r?\n)?/

export function announcementPushPreview(
  body: string | null | undefined,
  fallbackTitle?: string | null,
): string {
  const trimmed = (body ?? '').trim()
  if (!trimmed) return fallbackTitle?.trim() || 'New announcement'

  const match = trimmed.match(STRUCTURED_MARKER)
  if (!match) return trimmed

  const visibleText = trimmed.slice(match[0].length).trim()
  if (visibleText) return visibleText

  try {
    const parsed = JSON.parse(match[1]) as Record<string, unknown>
    if (parsed.kind === 'poll') {
      const question = String(parsed.question ?? '').trim()
      if (question) return `Poll: ${question}`
    }
    if (parsed.kind === 'jobs') {
      const lookingFor = String(parsed.lookingFor ?? '').trim()
      if (lookingFor) return lookingFor
    }
    if (parsed.kind === 'leave') {
      const leaveType = String(parsed.leaveType ?? '').trim()
      if (leaveType) return leaveType
    }
  } catch {
    /* corrupt marker — fall through to title */
  }

  return fallbackTitle?.trim() || 'New announcement'
}
